export default __webpack_public_path__ + "static/media/OneDrive_128x128.f15342e9.webp";